export default __webpack_public_path__ + "static/media/members.88ad9efb.svg";